import styled from "styled-components"
import { colors, device } from "../styles/stylesConfig"
import { memo, useContext } from "react"
import { useTranslation } from "react-i18next"
import { ThemeContext } from "../contexts/theme/ThemeContext"

const Container = styled.div`
    width: 80%;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 120px 0px;
    align-self: center;

    @media ${device.lg} {
        margin: 100px 0px;
    }

    @media ${device.md} {
        margin: 75px 0px;
    }

    @media ${device.sm} {
        margin: 60px 0px;
    }

`

const ManagersContainer = styled.div`
    width: 80%;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 50px 0px 150px;
    align-self: center;

    @media ${device.lg} {
        margin: 50px 0px 100px;
    }

    @media ${device.md} {
        margin: 50px 0px 75px;
    }

    @media ${device.sm} {
        margin: 50px 0px 60px;
    }

`

const ContentContainer = styled.div`
    width: 100%;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: start;
    justify-items: center;
    position: relative;
    gap: 100px;

    @media ${device.xl} {
        gap: 50px;
    }

    @media ${device.md} {
        grid-template-columns: repeat(1, 1fr);
        gap: 30px;

    }
`

const DataContainer = styled.div`
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    position: relative;
    padding: 30px 0px;
    
    @media ${device.md} {
        padding: 0px;
        align-items: center;
    }

`

const Image = styled.img`
    width: auto;
    height: 100%;
    max-height: 400px;
    margin-bottom: 15px;


    @media ${device.lg} {
        
    }
    
    @media ${device.md} {
        margin-bottom: 10px;

    }

    @media ${device.sm} {

    }
`

const TextInfo = styled.p<{ color: string }>`
    color: #222;
    color: ${({ color }) => (color)};
    font-size: 20px;
    line-height: 25px;
    margin-bottom: 5px;

    @media ${device.lg} {
        font-size: 18px;
    }
    
    @media ${device.md} {
        font-size: 16px;
        margin-bottom: 0px;
    }

    @media ${device.sm} {
        font-size: 14px;
    }
`

const Title = styled.div<{ color: string }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 60px;

    h2 {
        width: 100%;
        font-size: 38px;
        font-weight: 600;
        color: #2E2D2D;
        color: ${({ color }) => (color)};
        text-align: center;

        @media ${device.md} {
            font-size: 28px;
            text-align: center;

        }

        @media ${device.sm} {
            font-size: 24px;
        }

        @media ${device.xs} {
            font-size: 18px;
        }

    }
    
    @media ${device.sm} {
        margin-bottom: 50px;
    }

`


const Circle1 = styled.div`
    width: 250px;
    height: 250px;
    position: absolute;
    top: 0%;
    left: -15%;
    background-color: ${colors.primary};
    border-radius: 50%;

    @media ${device.lg} {
        width: 200px;
        height: 200px;
    }


    @media ${device.md} {
        top: 20%;
    }

    @media ${device.sm} {
        width: 100px;
        height: 100px;
    }
`

const Circle2 = styled.div`
    width: 350px;
    height: 350px;
    position: absolute;
    top: -30%;
    right: 0%;
    background-color: ${colors.danger};
    border-radius: 50%;

    @media ${device.lg} {
        width: 300px;
        height: 300px;
    }

    @media ${device.md} {
        top: -10%;
        right: -20%;
    }

    @media ${device.sm} {
        width: 200px;
        height: 200px;
    }
`

const Circle3 = styled.div`
    width: 250px;
    height: 250px;
    position: absolute;
    bottom: -40%;
    left: 0%;
    background-color: ${colors.danger};
    border-radius: 50%;

    @media ${device.lg} {
        width: 200px;
        height: 200px;
    }

    @media ${device.md} {
        bottom: 30%;
    }

    @media ${device.sm} {
        width: 100px;
        height: 100px;
    }

`

const Circle4 = styled.div`
    width: 350px;
    height: 350px;
    position: absolute;
    bottom: -30%;
    right: -20%;
    background-color: ${colors.primary};
    border-radius: 50%;

    @media ${device.lg} {
        width: 300px;
        height: 300px;
    }

    @media ${device.md} {
        bottom: 0%;
        right: -30%;
    }

    @media ${device.sm} {
        width: 200px;
        height: 200px;
    }

`

const Circle5 = styled.div`
    width: 300px;
    height: 300px;
    position: absolute;
    bottom: -10%;
    left: -20%;
    background-color: ${colors.primary};
    border-radius: 50%;

    @media ${device.lg} {
        width: 250px;
        height: 250px;
    }

    @media ${device.md} {
        bottom: 10%;
        left: -20%;
    }
    
    @media ${device.sm} {
        width: 150px;
        height: 150px;
    }

`

const Circle6 = styled.div`
    width: 250px;
    height: 250px;
    position: absolute;
    bottom: -40%;
    right: 10%;
    background-color: ${colors.danger};
    border-radius: 50%;

    @media ${device.lg} {
        width: 200px;
        height: 200px;
    }

    @media ${device.md} {
        bottom: -30%;
        right: -10%;
    }

    @media ${device.sm} {
        width: 100px;
        height: 100px;
        bottom: -10%;
    }
`

const TeamComponent = () => {

    const { t } = useTranslation();

    const {
        theme: { colors },
    } = useContext(ThemeContext);

    return (

        <>

            <Container key={'Team1'}>

                <Circle1 className="utils__fade-in-fast-right" />

                <Circle2 className="utils__fade-in-fast-center" />

                <Circle3 className="utils__fade-in-fast-bottom" />

                <Circle4 className="utils__fade-in-fast-left" />

                <Title
                    className="utils__fade-in-fast-top"
                    color={colors.text}
                >
                    <h2>{t('about.team.title.1')}</h2>
                </Title>


                <ContentContainer>

                    <DataContainer key={t('about.team.position.2') + '1'} className="utils__fade-in-fast-top">

                        <Image src={require('../images/integrante-agustin.webp')} alt="Imagen Agustin Gaetan Socio" />

                        <TextInfo
                            className="utils__fade-in-fast-top"
                            style={{ fontWeight: 500 }}
                            color={colors.text_light}
                        >
                            Agustín Gaetan
                        </TextInfo>

                        <TextInfo
                            className="utils__fade-in-fast-top"
                            style={{ fontWeight: 300 }}
                            color={colors.text_light}
                        >
                            {t('about.team.position.2')}
                        </TextInfo>

                    </DataContainer>

                    <DataContainer key={t('about.team.position.1') + ''} className="utils__fade-in-fast-top">

                        <Image src={require('../images/integrante-javier.webp')} alt="Imagen Javier Gaetan Socio" />

                        <TextInfo
                            className="utils__fade-in-fast-top"
                            style={{ fontWeight: 500 }}
                            color={colors.text_light}
                        >
                            Javier Gaetan
                        </TextInfo>

                        <TextInfo
                            className="utils__fade-in-fast-top"
                            style={{ fontWeight: 300 }}
                            color={colors.text_light}
                        >
                            {t('about.team.position.1')}
                        </TextInfo>

                    </DataContainer>

                    <DataContainer key={t('about.team.position.2') + '2'} className="utils__fade-in-fast-top">

                        <Image src={require('../images/integrante-julian.webp')} alt="Imagen Julian Gaetan Socio" />

                        <TextInfo
                            className="utils__fade-in-fast-top"
                            style={{ fontWeight: 500 }}
                            color={colors.text_light}
                        >
                            Julian Gaetan
                        </TextInfo>

                        <TextInfo
                            className="utils__fade-in-fast-top"
                            style={{ fontWeight: 300 }}
                            color={colors.text_light}
                        >
                            {t('about.team.position.2')}
                        </TextInfo>

                    </DataContainer>

                </ContentContainer>

            </Container>

            {/* <ManagersContainer key={'Team2'}>

                <Circle5 className="utils__fade-in-fast-right" />

                <Circle6 className="utils__fade-in-fast-center" />

                <Title
                    className="utils__fade-in-fast-top"
                    color={colors.text}
                >
                    <h2>{t('about.team.title.2')}</h2>
                </Title>


                <ContentContainer style={{ gridTemplateColumns: '1fr' }}>

                    <DataContainer key={t('about.team.position.3')} className="utils__fade-in-fast-top" style={{ padding: 0, alignItems: 'center' }}>

                        <Image src={require('../images/integrante-walter.webp')} alt="Imagen Eric Walter Widder Socio" />

                        <TextInfo
                            className="utils__fade-in-fast-top"
                            style={{ fontWeight: 500 }}
                            color={colors.text_light}
                        >
                            Eric Walter Widder
                        </TextInfo>

                        <TextInfo
                            className="utils__fade-in-fast-top"
                            style={{ fontWeight: 300 }}
                            color={colors.text_light}
                        >
                            {t('about.team.position.3')}
                        </TextInfo>

                    </DataContainer>

                </ContentContainer>

            </ManagersContainer> */}

        </>

    )
}

const Team = memo(TeamComponent);

export default Team;